// Use discount tiers from the shop.metafields.bundle_builder.discount_tiers metafield if
// available, otherwise fall back to the legacy hardcoded tiers. Sorted descending by `min`
// so the first match is the highest tier the current quantity qualifies for.
const discountTiers = (
  window.bundleDiscountTiers || [
    { min: 3, percent: 15 },
    { min: 4, percent: 20 },
    { min: 6, percent: 30 },
  ]
)
  .slice()
  .sort((a, b) => b.min - a.min);

// Use messages from Liquid settings if available, otherwise use defaults
const bundleMessages = window.bundleMessagesFromSettings || [
  '<span><strong>Your bundle is empty! </strong>Start building your bundle and unlock <strong>Free Shipping & Amazing discounts!</strong></span>',
  "<span><strong>Look at you go! </strong>You've got yourself <strong>Free Shipping</strong>. Add <strong>2</strong> more items to save 15%.</span>",
  "<span><strong>Look at you go! </strong>You've got yourself <strong>Free Shipping</strong>. Add <strong>1</strong> more item to save 15%.</span>",
  "<span><strong>Look at you go! </strong>You've got yourself <strong>Free Shipping & 15% off </strong>all items in your bundle. Add <strong>1</strong> more item to save 20%.</span>",
  "<span><strong>Look at you go! </strong>You've got yourself <strong>Free Shipping & 20% off </strong>all items in your bundle. Add <strong>2</strong> more items to save 30%.</span>",
  "<span><strong>Look at you go! </strong>You've got yourself <strong>Free Shipping & 20% off </strong>all items in your bundle. Add <strong>1</strong> more item to save 30%.</span>",
  "<span><strong>You did it! </strong>You've got yourself <strong>Free Shipping & 30% off </strong>all items in your bundle. Why stop here? Add more items to <strong>maximize your savings</strong> and stock up on your favorites!.</span>",
];

class BundleCartMain extends HTMLElement {
  constructor() {
    super();
    this.bundleContainer = this.querySelector('.bundles-container');
    // this.getCartBtn = this.querySelector(".getCart")
    this.selectedVariants = [];
    this.selectedVariantsNumber = this.querySelector('.selectedVariantsNumber');
    this.submitButtonMain = this.querySelector('#submitButton');
    this.discountText = this.querySelector('.selectedDiscountNumber');
    this.variants = this.bundleContainer.querySelectorAll('.variant-id');
    this.bundlesContainer = this.querySelector('#bundles-container');
    this.bundleActionContainer = this.querySelector('#bundle-action-container');
    this.allItemsReference = this.querySelectorAll('bundle-item');
    this.bundleOpenBtn = this.querySelector('[data-bundle-open]');
    this.bundleWrap = this.querySelector('.bundle-wrap');
    this.hiddenHeader = this.querySelector('.bundle-mobile-header-helper');
    this.header = this.querySelector('#bundleHeader');
    this.overlay = null;
    this.onOverlayClick = this.onOverlayClick.bind(this);
    window.addEventListener('DOMContentLoaded', (e) => {
      this.init();
    });
    this.items = [];
    this.itemsMap = new Map();
    this.submitButtonMain.addEventListener('click', () => {
      this.createBundleRequest();
    });
  }

  async init() {
    function getAmendValue() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('amend');
    }
    const amend = getAmendValue();
    if (amend) {
      this.header.scrollIntoView({ behavior: 'smooth' });
      await this.getCartForAmend(amend);
    } else {
      this.addEventListener('allItemsGathered', async () => {
        try {
          await this.#restoreFromSession();
          const event = new Event('fireUpsell');
          document.querySelector('bundle-upsells').dispatchEvent(event);
        } catch (error) {
          console.error('Error updating variants:', error);
        }
      });
    }
    const result = await this.bundlesContainer.getPaginatedData();
    const count = this.querySelectorAll('.variant-id').length;

    this.bundleOpenBtn.addEventListener('click', () => {
      const overlay = document.querySelector('[data-theme-overlay]');
      if (overlay?.classList.contains('js-is-visible')) {
        window.setOverlay(); // deactivate
      } else {
        window.setOverlay('active'); // activate
      }
      this.bundleOpenBtn.classList.toggle('js-is-active');
      this.bundleWrap.classList.toggle('js-is-visible');
    });

    this.overlay = document.querySelector('[data-theme-overlay]');
    if (this.overlay) {
      this.overlay.removeEventListener('click', this.onOverlayClick);
      this.overlay.addEventListener('click', this.onOverlayClick);
    }

    this.setTopFromSiteHeader();
    window.addEventListener('resize', () => this.setTopFromSiteHeader());
    window.addEventListener('orientationchange', () => this.setTopFromSiteHeader());
    // this.bundleOpenBtn.addEventListener('click', () => {
    //   this.bundleWrap.classList.add('open-bundle-preview');
    //   this.bundleOpenBtn.classList.add('b-e-hide');
    //   this.bundleActionContainer.classList.add('action-fixed');
    //   document.body.style.overflow = 'hidden';
    // });
    // this.hiddenHeader.addEventListener('click', () => {
    //   this.bundleWrap.classList.remove('open-bundle-preview');
    //   this.bundleOpenBtn.classList.remove('b-e-hide');
    //   this.bundleActionContainer.classList.remove('action-fixed');
    //   document.body.style.overflow = '';
    // });

    this.changeVisibleItems('everything-collection');
  }

  setTopFromSiteHeader() {
    const headers = Array.from(document.querySelectorAll('.site-header'));
    const totalHeaderHeight = headers.reduce((sum, header) => sum + header.getBoundingClientRect().height, 0);
    const topValue = `${Math.round(totalHeaderHeight)}px`;
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const maxHeight = this.getBundleActionMaxHeight(totalHeaderHeight, viewportHeight, isMobile);

    // if (this.bundleWrap) {
    //   this.bundleWrap.style.top = topValue;
    // }

    // if (this.hiddenHeader) {
    //   this.hiddenHeader.style.top = topValue;
    // }

    if (this.bundleActionContainer) {
      // this.bundleActionContainer.style.top = topValue;
      this.bundleActionContainer.style.maxHeight = maxHeight;
    }
  }

  getBundleActionMaxHeight(totalHeaderHeight, viewportHeight, isMobile) {
    const desktopExtraOffset = isMobile ? 0 : 40;
    return `${Math.max(0, Math.floor(viewportHeight - totalHeaderHeight - desktopExtraOffset))}px`;
  }

  onOverlayClick() {
    this.bundleOpenBtn?.classList.remove('js-is-active');
    this.bundleWrap?.classList.remove('js-is-visible');
    window.setOverlay();
  }

  async getCartForAmend(amend_value) {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response) {
      const json = await response.json();
      const items = json.items;
      let idsInCart = [];
      items.forEach((item) => {
        const bundleId = item?.properties?._amendBundleId || '';
        idsInCart.push(bundleId);
      });
      const amend_index = idsInCart.findIndex((id) => id === amend_value);
      if (amend_index >= 0) {
        items.forEach((item, idx) => {
          if (idx !== amend_index) {
            return;
          }
          const bundleId = item?.properties?._amendBundleId || '';
          const parsed = JSON.parse(item?.properties?._variantsString);
          const varAndQty = parsed.map((entity) => {
            const str = entity.gid;
            const variantId = str.split('/').pop();
            const quantity = Number(entity.quantity);
            return { variantId, quantity };
          });
          idsInCart.push(bundleId);
          async function updateVariants(varAndQty, context) {
            for (const variant of varAndQty) {
              context.requestVariantUpdate(variant.variantId, variant.quantity);
              const targets = [...document.querySelectorAll('bundle-item')];
              const foundTarget = targets.findIndex((item1) => {
                return item1.state.some((item2) => item2.variantId === variant.variantId);
              });
              if (foundTarget >= 0) {
                targets[foundTarget].changeVariantInPlace();
              }
              await new Promise((resolve) => setTimeout(resolve, 500));
            }
          }
          this.addEventListener('allItemsGathered', async () => {
            try {
              await updateVariants(varAndQty, this);
              const event = new Event('fireUpsell');
              document.querySelector('bundle-upsells').dispatchEvent(event);
            } catch (error) {
              console.error('Error updating variants:', error);
            }
          });
        });
      }
    }
  }

  createBundleRequest() {
    if (this.itemsMap.size > 0) {
      const bundleId = String(new Date().getTime());
      const bundleVariantId = this.getAttribute('data-bundle-variant-id') || '';

      // Add each product variant as a separate cart line with _bundleId.
      // The cart transform function will merge these into a single bundle
      // line and apply the tiered discount automatically.
      const payload = [];
      for (const [key, value] of this.itemsMap) {
        payload.push({
          id: value.variantId,
          quantity: value.quantity,
          properties: {
            _bundleId: bundleId,
            _label: value?.label || '',
            _title: value?.title || '',
            _bundleParentVariantId: bundleVariantId,
          },
        });
      }

      console.log('Bundle: adding to cart with payload', payload);
      this.handleSubmit(payload);
    } else {
      console.log('NO ITEMS IN THE BUNDLE');
    }
  }
  reset() {
    document.querySelector('bundle-upsells').revertUpsells();
    this.allItemsReference = this.querySelectorAll('bundle-item');
    this.items.forEach((item) => (item.quantity = 0));
    this.prepareItemsInTheBundle();
    this.allItemsReference.forEach((item) => item.changeVariantInPlace());
    setTimeout(() => {
      const event = new Event('fireUpsell');
      document.querySelector('bundle-upsells').dispatchEvent(event);
    });
  }
  checkSubmit() {
    if (this.selectedVariants.length > 0) {
      this.submitButton.classList.remove('hidden');
    } else {
      this.submitButton.classList.add('hidden');
    }
  }
  test() {
    console.log('test');
  }
  async getCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
  createBundle(ids = []) {
    const bundleId = String(new Date().getTime());
    const itemCount = ids.reduce((acc, item) => {
      acc[item] = {
        id: item,
        quantity: 1,
        properties: {
          _bundleId: bundleId,
        },
      };
      return acc;
    }, {});
    const itemsPayload = Object.values(itemCount);

    this.handleSubmit(itemsPayload);
  }

  getCartSectionsOptions() {
    const sections = window.Herd?.utils?.sectionRenderer?.popoutCartSections?.map((section) => section.section) || [];

    return {
      sections,
      sectionsUrl: window.location.pathname + window.location.search,
    };
  }

  getCollectionOrder() {
    if (this.collectionOrder) return this.collectionOrder;
    try {
      this.collectionOrder = JSON.parse(document.getElementById('bundle-collection-order')?.textContent || '{}');
    } catch (e) {
      this.collectionOrder = {};
    }
    return this.collectionOrder;
  }

  changeVisibleItems(collection_id) {
    this.variants = this.bundleContainer.querySelectorAll('.variant-id');
    const variants = this.variants;
    // Match the collection's own sort order using CSS `order`; products not in the list keep their source order at the end
    const productOrder = (this.getCollectionOrder()[collection_id] || []).map(String);
    variants.forEach((variant, index) => {
      const position = productOrder.indexOf(variant.getAttribute('data-variant-id'));
      variant.style.order = productOrder.length ? (position === -1 ? productOrder.length : position) : '';
      const variantIds = variant.querySelector('.variant-collection-ids').innerText.trim().slice(1, -1).split(',');
      // const variantCollectionRaw = variant.getAttribute("data-product-collections")
      // const variantCollections = variantCollectionRaw.split(",").filter(item => !!item)
      const variantIsInTheCollection = variantIds.includes(collection_id);
      if (collection_id === 'everything-collection') {
        variant.classList.remove('v-hidden');

        variant.classList.remove('v-o-hidden');
      } else {
        variantIsInTheCollection ? variant.classList.remove('v-hidden') : variant.classList.add('v-hidden');
        variantIsInTheCollection ? variant.classList.remove('v-o-hidden') : variant.classList.add('v-o-hidden');
      }
    });
  }
  //   44218987151536
  async handleSubmit(payload) {
    // this.submitButton.classList.add("events-none");
    // this.submitButton.classList.add("loading");

    function getAmendValue() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('amend');
    }
    const amend = getAmendValue();
    if (amend) {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response) {
        const json = await response.json();

        const items = json.items;
        let idsInCart = [];
        items.forEach((item) => {
          const bundleId = item?.properties?._amendBundleId || '';
          idsInCart.push(bundleId);
        });
        const amend_index = idsInCart.findIndex((id) => id === amend);

        if (amend_index >= 0) {
          const variant_id = items[amend_index].variant_id;
          let updates = {
            [variant_id]: 0,
          };
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          })
            .then((response) => response.json())
            .then((data) => console.log('Success:', data))
            .catch((error) => console.error('Error:', error));
        }
      }
    }

    try {
      if (window.Herd?.Cart?.addItems) {
        await window.Herd.Cart.addItems(payload, this.getCartSectionsOptions());
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: payload,
          }),
        });
      }

      this.reset();

      const hideMobileBundle = document.querySelector('.bundle-mobile-header-helper');
      if (hideMobileBundle && this.bundleWrap?.classList.contains('open-bundle-preview')) {
        hideMobileBundle.click();
      }
    } catch (e) {
      console.log(e);
    } finally {
      const url = new URL(window.location);
      url.search = '';
      window.history.replaceState({}, document.title, url.toString());

      console.log('FINISHED');
    }
  }
  getItemInTheBundle(variant_id) {
    const found = this.items.findIndex((item) => item.variantId === variant_id);
    if (found !== -1) {
      return this.items[found];
    } else {
      return null;
    }
  }
  collectVariants(variant) {
    this.items.push(variant);
  }
  requestVariantUpdate(variant_id, quantity) {
    const foundIndex = this.items.findIndex((item) => item.variantId === variant_id);
    if (foundIndex === -1) {
      return false;
    }
    const item = this.items[foundIndex];
    item.quantity = quantity;
    // const newPrices = this.#getNewPrice(item.priceNoZero, 3, 0.15)
    this.prepareItemsInTheBundle();
    return true;
  }
  prepareItemsInTheBundle() {
    const filtered = this.items.filter((item) => item.quantity > 0);
    const filteredLength = filtered.reduce((acc, curr) => acc + curr.quantity, 0);

    if (filteredLength <= 0) {
      this.bundleOpenBtn?.classList.remove('js-is-active');
      this.bundleWrap?.classList.remove('js-is-visible');
    }

    const currentDiscount = this.#getCurrentDiscount(filteredLength);
    filtered.forEach((stageItem) => {
      const newPrices = this.#getNewPrice(stageItem.priceNoZero, stageItem.quantity, currentDiscount);
      stageItem.priceBefore = newPrices.priceBefore;
      stageItem.priceAfter = newPrices.priceAfter;

      this.itemsMap.set(stageItem.variantId, stageItem);
    });
    let zeroItems = [];
    for (const [key, value] of this.itemsMap) {
      if (value.quantity < 1) {
        zeroItems.push(key);
      }
    }
    zeroItems.forEach((key) => this.itemsMap.delete(key));
    this.bundleActionContainer.updateBundle(this.itemsMap);
    this.#saveToSession();
  }
  #saveToSession() {
    const state = [];
    for (const [, value] of this.itemsMap) {
      state.push({ variantId: value.variantId, quantity: value.quantity });
    }
    if (state.length === 0) {
      sessionStorage.removeItem('bundle_cart_state');
    } else {
      sessionStorage.setItem('bundle_cart_state', JSON.stringify(state));
    }
  }
  async #restoreFromSession() {
    const saved = sessionStorage.getItem('bundle_cart_state');
    if (!saved) return;
    try {
      const state = JSON.parse(saved);
      if (!Array.isArray(state) || state.length === 0) return;
      for (const { variantId, quantity } of state) {
        this.requestVariantUpdate(variantId, quantity);
        const targets = [...document.querySelectorAll('bundle-item')];
        const foundTarget = targets.findIndex((item) => item.state.some((s) => s.variantId === variantId));
        if (foundTarget >= 0) {
          targets[foundTarget].changeVariantInPlace();
        }
      }
    } catch (e) {
      console.error('Error restoring bundle from session:', e);
    }
  }
  #getCurrentDiscount(num) {
    const tier = discountTiers.find((t) => num >= t.min);
    return tier ? tier.percent / 100 : 0;
  }
  #getNewPrice(price_with_currency, quantity, discount) {
    const currency = price_with_currency[0];
    const price = Number(price_with_currency.slice(1));
    const fullPrice = price * quantity;
    const discountedPrice = fullPrice * (1 - discount);
    const discountedPriceFixed = this.decimalAdjust('ceil', discountedPrice, -2);
    return {
      priceBefore: currency + String(fullPrice.toFixed(2)),
      priceAfter: currency + String(discountedPriceFixed.toFixed(2)),
    };
    // console.log(currency, price, fullPrice, discountedPrice, discountedPriceFixed)
  }
  decimalAdjust(type, value, exp) {
    type = String(type);
    if (!['round', 'floor', 'ceil'].includes(type)) {
      throw new TypeError("The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'.");
    }
    exp = Number(exp);
    value = Number(value);
    if (exp % 1 !== 0 || Number.isNaN(value)) {
      return NaN;
    } else if (exp === 0) {
      return Math[type](value);
    }
    const [magnitude, exponent = 0] = value.toString().split('e');
    const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`);
    // Shift back
    const [newMagnitude, newExponent = 0] = adjustedValue.toString().split('e');
    return Number(`${newMagnitude}e${+newExponent + exp}`);
  }
}
customElements.define('bundle-cart-main', BundleCartMain);

// Bundle Header
class BundleCartHeader extends HTMLElement {
  constructor() {
    super();
    this.bundleContainerMain = document.getElementById('bundle-cart-main');
    // this.leftScrollButton = this.querySelector('#bundle-header-scroll-btn-left');
    // this.rightScrollButton = this.querySelector('#bundle-header-scroll-btn-right');
    // this.scrollContainer = this.querySelector('#bundle-header-scroll__container');
    this.collections = this.querySelectorAll('.bundle-header-scroll__item');
    this.fetchButton = document.getElementById('fetchButton');
    this.descriptions = document.getElementById('bundle-cart-col-descriptions');
    this.initScrollButtons();
  }

  initScrollButtons() {
    this.collections.forEach((collection) => {
      collection.addEventListener('click', (e) => {
        e.stopPropagation();
        const collectionId = collection.getAttribute('data-collection-id');

        this.bundleContainerMain.changeVisibleItems(collectionId || '');
        this.changeClickedCollection(collectionId || '');
        this.descriptions.updateDescriptionVisibility(collectionId || '');
      });
      collection.addEventListener('mouseenter', (e) => {
        collection.classList.add('selected');
      });
      collection.addEventListener('mouseleave', (e) => {
        collection.classList.remove('selected');
      });
    });

    // this.rightScrollButton &&
    //   this.rightScrollButton.addEventListener('click', (e) => {
    //     e.stopPropagation();
    //     this.scrollRight();
    //   });
    // this.leftScrollButton &&
    //   this.leftScrollButton.addEventListener('click', (e) => {
    //     e.stopPropagation();
    //     this.scrollLeft();
    //   });
    // this.updateButtonVisibility();
    // this.scrollContainer.addEventListener('scroll', () => this.updateButtonVisibility());
  }
  changeClickedCollection(collection_id) {
    this.collections.forEach((collection) => {
      const collectionId = collection.getAttribute('data-collection-id');
      if (collectionId === collection_id) {
        collection.classList.add('collection-active');
      } else {
        collection.classList.remove('collection-active');
      }
    });
  }

  scrollLeft() {
    // this.scrollContainer.scrollBy({ left: -200, behavior: 'smooth' });
  }
  scrollRight() {
    // this.scrollContainer.scrollBy({ left: 200, behavior: 'smooth' });
  }
  updateButtonVisibility() {
    // const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
    // if (scrollLeft <= 0) {
    //   this.leftScrollButton.style.display = 'none';
    // } else {
    //   this.leftScrollButton.style.display = 'block';
    // }
    // // Hide right button if fully scrolled right
    // if (scrollLeft + clientWidth >= scrollWidth - 1) {
    //   this.rightScrollButton.style.display = 'none';
    // } else {
    //   this.rightScrollButton.style.display = 'block';
    // }
  }
}
customElements.define('bundle-cart-header', BundleCartHeader);

class BundlesContainer extends HTMLElement {
  constructor() {
    super();
    this.father = document.getElementById('bundle-cart-main');
    this.items = [];
  }

  async getPaginatedData() {
    const pagesElement = this.querySelector('#paginateLink');
    if (!pagesElement) {
      console.error('Pagination element not found.');
      return;
    }

    const pagesCount = Number(pagesElement.getAttribute('data-paginate-pages'));
    if (pagesCount < 2) return; // No additional pages to fetch

    const fetchPagesArray = [];
    for (let pageNumber = 2; pageNumber <= pagesCount; pageNumber++) {
      fetchPagesArray.push({ url: `/pages/bundle?page=${pageNumber}`, pageNumber });
    }

    try {
      // Fetch all pages in parallel, but allow failures
      const responses = await Promise.allSettled(
        fetchPagesArray.map(({ url }) =>
          fetch(url).then((res) => {
            if (!res.ok) throw new Error(`Failed to fetch ${url} (status: ${res.status})`);
            return res.text();
          }),
        ),
      );

      // Process only successful responses
      const orderedResponses = fetchPagesArray
        .map((entry, i) => ({
          pageNumber: entry.pageNumber,
          html: responses[i].status === 'fulfilled' ? responses[i].value : null,
        }))
        .filter((response) => response.html !== null) // Remove failed fetches
        .sort((a, b) => a.pageNumber - b.pageNumber); // Maintain order

      // Append fetched content in order

      orderedResponses.forEach(({ html }) => {
        const parser = new DOMParser();
        const parsedDocument = parser.parseFromString(html, 'text/html');
        const bundleItems = parsedDocument.querySelectorAll('.bundle-item');
        bundleItems.forEach((item) => {
          this.appendChild(item.cloneNode(true));
        });
      });

      responses.forEach((result, i) => {
        if (result.status === 'rejected') {
          console.error(`Error fetching page ${fetchPagesArray[i].pageNumber}:`, result.reason);
        }
      });

      const interval = setInterval(() => {
        const count = [...document.querySelectorAll('bundle-item')].length;

        const statuses = [...document.querySelectorAll('bundle-item')].map((item) => item.getStatus());
        const everyTrue = statuses.every((val) => val);
        if (everyTrue && statuses.length === count) {
          const event = new Event('allItemsGathered');
          this.father.dispatchEvent(event);

          clearInterval(interval);
        }
      }, 500);
      return 1;
    } catch (error) {
      console.error('Unexpected error in getPaginatedData:', error);
      return 0;
    }
  }
}
customElements.define('bundles-container', BundlesContainer);

class BundleActionContainer extends HTMLElement {
  constructor() {
    super();
    this.main = document.querySelector('#bundle-cart-main');
    this.moveLeft = this.querySelector('.move-left');
    this.moveRight = this.querySelector('.move-right');
    this.carousel = this.querySelector('bundle-carousel');
    this.template = this.querySelector('[data-item-bundle-template]');
    this.itemsContainer = this.querySelector('#actionContainer__bundle-items');
    this.allItemsReference = this.main.querySelectorAll('bundle-item');
    this.fullPrice = this.querySelector('.item-in-bundle__bundle-totals-price__full');
    this.discountedPrice = this.querySelector('.item-in-bundle__bundle-totals-price__discounted');
    this.savingsPrice = this.querySelector('.actionContainer__bundle-totals__savings');
    this.totals = this.querySelector('.actionContainer__bundle-totals');
    this.mobilePrice = this.querySelector('.bundle-open__controls__price');
    this.bybTitle = this.querySelector('.actionContainer-title-mobile');
    this.bundleOpenBtn = this.querySelector('.bundle-open-btn-btn');
    this.submitButton = this.querySelector('#submitButton');
    this.mobilePriceFull = this.querySelector('.bundle-open__price__full');
    this.upsellsContainer = this.querySelector('#bundle-upsells');
    this.mobilePriceDiscounted = this.querySelector('.bundle-open__price__discounted');
  }
  updateBundle(items) {
    let elements = [];
    let newItems = [];
    for (const [key, value] of items) {
      const node = this.createItemTemplate(value);
      elements.push(node);
      newItems.push(value);
    }

    if (newItems.length === 0) {
      // this.bundleOpenBtn.classList.add('b-w-full');
      // this.mobilePrice.classList.add('b-e-hide');
      // this.bybTitle.classList.add('b-e-hide');
      this.itemsContainer.classList.add('b-e-hide');
      this.submitButton.classList.add('b-e-hide');
    } else {
      // this.bundleOpenBtn.classList.remove('b-w-full');
      // this.mobilePrice.classList.remove('b-e-hide');
      // this.bybTitle.classList.remove('b-e-hide');
      this.itemsContainer.classList.remove('b-e-hide');
      this.submitButton.classList.remove('b-e-hide');
    }
    this.itemsContainer.innerHTML = '';
    elements.forEach((element) => {
      this.itemsContainer.appendChild(element);
    });
    const filteredLength = newItems.reduce((acc, curr) => acc + curr.quantity, 0);
    if (filteredLength > 0) {
      this.totals.classList.remove('b-e-hide');
    } else {
      this.totals.classList.add('b-e-hide');
    }
    const currency = newItems[0]?.priceBefore.slice(0, 1) || '';
    const newBeforePrice = newItems.reduce((acc, curr) => {
      const sliced = Number(curr.priceBefore.slice(1));
      return acc + sliced;
    }, 0);
    const newAfterPrice = newItems.reduce((acc, curr) => {
      const sliced = Number(curr.priceAfter.slice(1));
      return acc + sliced;
    }, 0);
    const priceDiff = newBeforePrice - newAfterPrice;

    if (priceDiff === 0) {
      this.savingsPrice.classList.add('b-e-hide');
      this.fullPrice.classList.add('b-e-hide');
      this.discountedPrice.innerText = `${currency}${newAfterPrice.toFixed(2)}`;
      // this.mobilePriceDiscounted.innerText = `${currency}${newAfterPrice.toFixed(2)}`;
      // this.mobilePriceFull.classList.add('b-e-hide');
    } else {
      this.savingsPrice.classList.remove('b-e-hide');
      this.savingsPrice.innerHTML = `<strong>YOU SAVE ${currency}${priceDiff.toFixed(2)}</strong>`;
      this.discountedPrice.innerText = `${currency}${newAfterPrice.toFixed(2)}`;
      this.discountedPrice.classList.remove('b-e-hide');
      this.fullPrice.classList.remove('b-e-hide');
      // this.mobilePriceDiscounted.innerText = `${currency}${newAfterPrice.toFixed(2)}`;
      // this.mobilePriceFull.innerText = `${currency}${newBeforePrice.toFixed(2)}`;
      // this.mobilePriceFull.classList.remove('b-e-hide');
      this.fullPrice.innerHTML = `${currency}${newBeforePrice.toFixed(2)}`;
    }

    const bundlePriceSpan = this.main?.querySelector('[data-bundle-price]');
    if (bundlePriceSpan) {
      bundlePriceSpan.hidden = false;
      bundlePriceSpan.innerText = newAfterPrice > 0 ? `${currency}${newAfterPrice.toFixed(2)}` : '';
    }

    const bundleCompareAtPriceSpan = this.main?.querySelector('[data-bundle-compare-at-price]');
    if (bundleCompareAtPriceSpan) {
      bundleCompareAtPriceSpan.hidden = false;
      bundleCompareAtPriceSpan.innerText =
        priceDiff > 0 && newBeforePrice > 0 ? `${currency}${newBeforePrice.toFixed(2)}` : '';
    }

    this.carousel.moveLeft(filteredLength);
  }
  addUpsell() {
    const node = document.createElement('div');
    node.innerText = 'New Node';
    node.addEventListener('click', () => {
      console.log(this.testing());
    });
    this.upsellsContainer.appendChild(node);
  }
  testing() {
    return 'TEST SUCCESS';
  }
  // const items = [
  //   {
  //     variantId: Number,
  //     quantity: Number,
  //     image_url: String,
  //     title: String,
  //     subtitle: String,
  //     priceRaw: String,
  //     price: String,
  //     priceFormatted: String,
  //     priceAfter: String,
  //     priceBefore: String,
  //     label: String
  //   }
  // ]
  createItemTemplate(item) {
    const clone = this.template.cloneNode(true);
    clone.classList.remove('b-e-hide');
    const title = clone.querySelector('.item-in-bundle__title');
    // const subtitle = clone.querySelector('.item-in-bundle__variant');
    const size = clone.querySelector('.item-in-bundle__size');
    const priceFull = clone.querySelector('.item-in-bundle__controls__price__full');
    const priceDiscounted = clone.querySelector('.item-in-bundle__controls__price__discounted');
    const quantity = clone.querySelector('.item-in-bundle__quantity');
    const imageWrap = clone.querySelector('.item-in-bundle__image');
    const removeButton = clone.querySelector('.item-in-bundle__remove-btn');
    const clonePlus = clone.querySelector('.item-in-bundle__plus');
    const cloneMinus = clone.querySelector('.item-in-bundle__minus');
    const hyphenIndex = item.title.indexOf(' - ');
    if (hyphenIndex !== -1) {
      title.innerHTML =
        item.title.slice(0, hyphenIndex) + ' <strong>' + item.title.slice(hyphenIndex + 3) + '</strong>';
    } else {
      title.innerText = item.title;
    }
    // subtitle.innerText = item.subtitle || '';
    size.innerText = item.label;
    priceFull.innerText = item.priceBefore;
    if (item.priceBefore === item.priceAfter) {
      priceFull.classList.add('b-e-hide');
    } else {
      priceFull.classList.remove('b-e-hide');
    }
    priceDiscounted.innerText = item.priceAfter;
    quantity.innerText = item.quantity;
    const image = document.createElement('img');
    image.setAttribute('src', item.image_url);
    imageWrap.appendChild(image);
    removeButton.addEventListener('click', () => {
      this.allItemsReference = this.main.querySelectorAll('bundle-item');
      const foundTarget = [...this.allItemsReference].findIndex((item1) => {
        return item1.state.some((item2) => item2.variantId === item.variantId);
      });

      if (foundTarget >= 0) {
        this.main.requestVariantUpdate(item.variantId, 0);
        this.allItemsReference[foundTarget].changeVariantInPlace();
      }
    });
    clonePlus.addEventListener('click', () => {
      this.allItemsReference = this.main.querySelectorAll('bundle-item');
      const input = Number(clone.querySelector('.item-in-bundle__quantity').innerText);

      const foundTarget = [...this.allItemsReference].findIndex((item1) => {
        return item1.state.some((item2) => item2.variantId === item.variantId);
      });
      if (foundTarget >= 0) {
        this.main.requestVariantUpdate(item.variantId, input + 1);
        this.allItemsReference[foundTarget].changeVariantInPlace();
      }
    });
    cloneMinus.addEventListener('click', () => {
      this.allItemsReference = this.main.querySelectorAll('bundle-item');
      const input = Number(clone.querySelector('.item-in-bundle__quantity').innerText);

      const foundTarget = [...this.allItemsReference].findIndex((item1) => {
        return item1.state.some((item2) => item2.variantId === item.variantId);
      });
      if (foundTarget >= 0) {
        this.main.requestVariantUpdate(item.variantId, input - 1);
        this.allItemsReference[foundTarget].changeVariantInPlace();
      }
    });
    return clone;
  }
  // init() {
  //   this.moveLeft.addEventListener("click", () => {
  //     this.carousel.moveLeft()
  //   })
  //   this.moveRight.addEventListener("click", () => {
  //     this.carousel.moveRight()
  //   })
  // }
}
customElements.define('bundle-action-container', BundleActionContainer);

class BundleCarousel extends HTMLElement {
  constructor() {
    super();
    this.bgLine = this.querySelector('.bc-back');
    this.slider = this.querySelector('.bc-front');
    this.anchorOne = this.querySelector('#anchor-step-1');
    this.anchorTwo = this.querySelector('#anchor-step-2');
    this.currentPosition = '100%';
    this.bubble = this.querySelector('.bc-front-bubble');
    this.bundleInfoMessage = document.querySelector('#bundle-info-message');

    // Get the free shipping threshold from the bundle-cart-main element
    const bundleCartMain = document.getElementById('bundle-cart-main');
    this.freeShippingThreshold = bundleCartMain
      ? parseFloat(bundleCartMain.getAttribute('data-free-shipping-threshold') || '50')
      : 50;

    // this.slider.addEventListener('transitionstart', () => {
    //   const sliderEventStart = new Event('sliderEventStart');
    //   document.dispatchEvent(sliderEventStart);
    // });
    this.intervals = [];
    // this.slider.addEventListener('transitionend', () => {
    //   const sliderEventEnd = new Event('sliderEventEnd');
    //   document.dispatchEvent(sliderEventEnd);
    // });
    // this.stepTest = this.querySelector('#step-test');
    // const boundSome = this.some.bind(this);

    // document.addEventListener('sliderEventStart', boundSome);
    // document.addEventListener('sliderEventEnd', () => {
    //   this.intervals.forEach((int) => clearInterval(int));
    //   document.removeEventListener('sliderEventStart', boundSome);
    //   document.addEventListener('sliderEventStart', boundSome);
    // });

    this.items = 0;
  }
  some() {
    function touching(d1, d2) {
      let ox = d1.x > d2.x;
      return ox;
    }

    this.intervals.forEach((int) => clearInterval(int));
    const bubble = document.querySelector('.bc-front-bubble');
    if (!bubble) {
      return;
    }
    const targets = document.querySelectorAll('.step-main');
    const targetsWrap2 = document.querySelector('.bundle-carousel-wrap2');
    if (!targetsWrap2) {
      return;
    }
    const targets2 = targetsWrap2.querySelectorAll('.step-main');
    const targetCoords = [...targets].map((item) => item.getBoundingClientRect());

    // Get the discounted price to check for free shipping eligibility
    const actionContainer = document.querySelector('bundle-action-container');
    const discountedPriceElement = actionContainer?.discountedPrice;
    let discountedPrice = 0;

    if (discountedPriceElement) {
      const priceText = discountedPriceElement.innerText;
      discountedPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    }

    // Check if free shipping is disabled completely
    const isFreeshippingDisabled = this.freeShippingThreshold <= 0;

    // Only check for free shipping threshold if it's enabled
    const hasFreeshipping = !isFreeshippingDisabled && discountedPrice >= this.freeShippingThreshold;

    const intervalId = setInterval(() => {
      let div1 = bubble.getBoundingClientRect();
      targetCoords.forEach((target, idx) => {
        const t = touching(div1, target);

        // For the first bubble (delivery - idx 0), only highlight if free shipping is enabled and price > threshold
        if (idx === 0 && !isFreeshippingDisabled) {
          // Check if eligible for highlighting (price over threshold)
          const isEligible = targets[idx].classList.contains('eligible-for-highlight');

          if (t && isEligible) {
            try {
              targets[idx].classList.add('step-colored');
              targets2[idx].classList.add('step-colored');
            } catch (e) {
              return;
            }
          } else {
            try {
              targets[idx].classList.remove('step-colored');
              targets2[idx].classList.remove('step-colored');
            } catch (e) {
              return;
            }
          }
        }
        // For all other bubbles (discounts), use the normal logic.
        // Bubbles rendered with a data-quantity threshold are colored deterministically
        // by #applyRewardTierColors() instead, since their real DOM position doesn't
        // reliably line up with the animated bubble at every item count.
        else if (idx > 0 && !targets[idx].hasAttribute('data-quantity')) {
          if (t) {
            try {
              targets[idx].classList.add('step-colored');
              targets2[idx].classList.add('step-colored');
            } catch (e) {
              return;
            }
          } else {
            try {
              targets[idx].classList.remove('step-colored');
              targets2[idx].classList.remove('step-colored');
            } catch (e) {
              return;
            }
          }
        }
      });
    }, 10);
    this.intervals.push(intervalId);
  }
  #setBundleMessage() {
    let message = '';

    // Get the discounted price value from the BundleActionContainer
    const actionContainer = document.querySelector('bundle-action-container');
    const discountedPriceElement = actionContainer?.discountedPrice;
    let discountedPrice = 0;
    let currency = '$'; // Default fallback

    if (discountedPriceElement) {
      const priceText = discountedPriceElement.innerText;
      // Extract numeric value from price text (removes currency symbol)
      discountedPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      // Extract currency symbol from price text
      currency = priceText.replace(/[\d\s,.]/g, '');
    }

    // Use shop currency from Liquid if available
    if (window.currencySymbol) {
      // Extract currency symbol from money_format
      const shopCurrencySymbol = window.currencySymbol.replace(/\{\{\s*amount.*\}\}/g, '');
      if (shopCurrencySymbol) {
        currency = shopCurrencySymbol;
      }
    }

    // Check if free shipping is disabled completely
    const isFreeshippingDisabled = this.freeShippingThreshold <= 0;

    // Only check for free shipping threshold if it's enabled
    const hasFreeshipping = !isFreeshippingDisabled && discountedPrice >= this.freeShippingThreshold;

    if (this.items <= 0) {
      message = bundleMessages[0]; // Empty bundle message
    } else if (!isFreeshippingDisabled && !hasFreeshipping) {
      // If free shipping is enabled but price is under threshold, show a message to reach it
      const thresholdMessage = window.freeShippingThresholdMessage.replace(
        '[[freeShippingThreshold]]',
        `${currency}${this.freeShippingThreshold}`,
      );
      message = thresholdMessage;
    } else {
      // Free shipping is either disabled or price is over threshold
      if (this.items > 5) {
        message = bundleMessages[6]; // Message for 6+ items
      } else {
        message = bundleMessages[this.items]; // Message for current item count

        // Special handling for free shipping disabled: Replace free shipping mentions with empty string
        if (isFreeshippingDisabled) {
          // Use a temporary DOM element to parse and modify the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = message;

          // Find text nodes containing "Free Shipping" and remove them
          const findAndCleanText = (node) => {
            if (node.nodeType === Node.TEXT_NODE) {
              if (node.textContent.includes('Free Shipping')) {
                node.textContent = node.textContent.replace(/Free Shipping\s*(&|and)\s*/gi, '');
                node.textContent = node.textContent.replace(/Free Shipping/gi, '');
              }
            } else if (node.childNodes) {
              node.childNodes.forEach(findAndCleanText);
            }
          };

          findAndCleanText(tempDiv);
          message = tempDiv.innerHTML;
        }
      }
    }

    this.bundleInfoMessage.innerHTML = message;
    return;
  }
  // Mask width (`.bc-front`) needed so its left edge lines up with the center of `step`,
  // expressed as a percentage of the track, since the mask is right-anchored and shrinks
  // from the left as items are added.
  #widthToStep(step, fullWidth) {
    const stepOL = step.offsetLeft;
    const stepWidth = step.offsetWidth / 2;
    return ((fullWidth - stepOL - stepWidth) * 100) / fullWidth;
  }
  #getPosition(count) {
    const fullWidth = this.bgLine.offsetWidth;
    const rewardSteps = [...this.querySelectorAll('.step-main[data-quantity]')]
      .map((el) => ({
        quantity: Number(el.dataset.quantity),
        width: this.#widthToStep(el, fullWidth),
      }))
      .sort((a, b) => a.quantity - b.quantity);

    if (!rewardSteps.length) {
      // Legacy fallback for when no reward carries a data-quantity threshold
      // (e.g. the discount_tiers metafield isn't set up yet).
      let result = ['100%'];
      this.querySelectorAll('.bc-step-hide-start').forEach((step) => {
        result.push(`${this.#widthToStep(step, fullWidth)}%`);
      });
      result.push('50%');
      this.querySelectorAll('.bc-step-hide-end').forEach((step) => {
        result.push(`${this.#widthToStep(step, fullWidth)}%`);
      });
      result.push('0%');
      return count >= 6 ? '0%' : `${result[count]}`;
    }

    if (count <= 0) {
      return '100%';
    }

    const maxQuantity = rewardSteps[rewardSteps.length - 1].quantity;
    if (count >= maxQuantity) {
      return '0%';
    }

    let previous = { quantity: 0, width: 100 };
    for (const step of rewardSteps) {
      if (count < step.quantity) {
        const ratio = (count - previous.quantity) / (step.quantity - previous.quantity);
        return `${previous.width + (step.width - previous.width) * ratio}%`;
      }
      previous = step;
    }
    return '0%';
  }
  #applyRewardTierColors() {
    document.querySelectorAll('.step-main[data-quantity]').forEach((el) => {
      el.classList.toggle('step-colored', this.items >= Number(el.dataset.quantity));
    });
  }
  moveLeft(count) {
    this.items = count;
    this.#applyRewardTierColors();

    const result = this.#getPosition(this.items);
    this.slider.style.width = result;
    this.some();

    // Get discounted price to check for free shipping eligibility
    const actionContainer = document.querySelector('bundle-action-container');
    const discountedPriceElement = actionContainer?.discountedPrice;
    let discountedPrice = 0;

    if (discountedPriceElement) {
      const priceText = discountedPriceElement.innerText;
      discountedPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    }

    // Check if free shipping is disabled completely
    const isFreeshippingDisabled = this.freeShippingThreshold <= 0;

    // Only check for free shipping threshold if it's enabled
    const hasFreeshipping = !isFreeshippingDisabled && discountedPrice >= this.freeShippingThreshold;

    // Handle the bubble visibility
    if (result === '100%' || result === '0%') {
      this.bubble.classList.add('b-e-hide-mobile');
    } else {
      this.bubble.classList.remove('b-e-hide-mobile');
    }

    // Only update delivery bubble if free shipping is enabled
    if (!isFreeshippingDisabled) {
      // Get the delivery bubble and update its highlighting based on price
      const deliveryBubble = document.querySelector('.bc-step.step-main.left');
      const deliveryBubbleText = document.querySelector('.bc-step-text.step-main.left');

      if (deliveryBubble && deliveryBubbleText) {
        deliveryBubble.classList.toggle('js-is-active', hasFreeshipping);
        deliveryBubbleText.classList.toggle('js-is-active', hasFreeshipping);

        if (hasFreeshipping) {
          // Only add the colored class if the price is above the threshold
          deliveryBubble.classList.add('eligible-for-highlight');
          deliveryBubbleText.classList.add('eligible-for-highlight');
        } else {
          // Remove the special class if price is below threshold
          deliveryBubble.classList.remove('eligible-for-highlight');
          deliveryBubbleText.classList.remove('eligible-for-highlight');

          // Also ensure step-colored is removed
          deliveryBubble.classList.remove('step-colored');
          deliveryBubbleText.classList.remove('step-colored');
        }
      }
    } else {
      const deliveryBubble = document.querySelector('.bc-step.step-main.left');
      const deliveryBubbleText = document.querySelector('.bc-step-text.step-main.left');
      deliveryBubble?.classList.remove('js-is-active');
      deliveryBubbleText?.classList.remove('js-is-active');
    }

    this.#setBundleMessage();
  }
  moveRight() {
    this.items = this.items + 1;
    const result = this.#getPosition(this.items);

    this.slider.style.width = result;
    this.#setBundleMessage();
  }
}
customElements.define('bundle-carousel', BundleCarousel);
const items = [
  {
    variantId: Number,
    quantity: Number,
    image_url: String,
    title: String,
    subtitle: String,
    priceRaw: String,
    price: String,
    priceFormatted: String,
    priceAfter: String,
    priceBefore: String,
    label: String,
  },
];
class BundleItem extends HTMLElement {
  constructor() {
    super();

    this.init();
  }
  connectedCallback() {
    // Initialize the Intersection Observer when the element is attached to the DOM
    this.initObserver();
  }

  disconnectedCallback() {
    // Clean up the observer when the element is removed from the DOM
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  initObserver() {
    // Create an Intersection Observer to detect when this element is in view
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const productSku = this.getAttribute('data-product-sku');
          const productVariantSku = this.getAttribute('data-product-sku_t');
          const firstSku = productSku || productVariantSku;
          if (firstSku) {
            this.fetchReviewsByApi(firstSku);
          }

          this.disconnectedCallback();
          // You can add any additional actions here when the element is visible
        }
      });
    });
    // Observe this element
    this.observer.observe(this);
  }

  fetchReviewsByApi = async (sku) => {
    const reviewIO = {
      url: 'https://api.reviews.io/product/review',
      store: 'dock-bay',
      apikey: 'fb2744bdab45cf88c652c5c509962b86',
    };
    const response = await fetch(`${reviewIO.url}?store=${reviewIO.store}&sku=${sku}&apikey=${reviewIO.apikey}`);
    const result = await response.json();
    const target = this.querySelector('.bundle-product-rating');
    if (result?.stats?.average) {
      const rating = parseFloat(result.stats.average);

      // Function to generate star HTML based on the rating
      const renderStars = (rating) => {
        let fullStars = Math.floor(rating);
        let halfStar = 0;
        const remainder = rating - fullStars;

        if (remainder > 0) {
          // Use a half star if the decimal part is 0.5 or less; otherwise, round up.
          if (remainder <= 0.5) {
            halfStar = 1;
          } else {
            fullStars++;
          }
        }

        const emptyStars = 5 - fullStars - halfStar;
        let starsHtml = '';

        // Append full stars (★)
        for (let i = 0; i < fullStars; i++) {
          starsHtml += '<span class="star">&#9733;</span>';
        }
        // Append a half star if needed (using a half-overlay effect via CSS)
        if (halfStar) {
          starsHtml += '<span class="star half">&#9733;</span>';
        }
        // Append empty stars (☆)
        for (let i = 0; i < emptyStars; i++) {
          starsHtml += '<span class="star empty">&#9734;</span>';
        }
        return starsHtml;
      };

      // Insert the rendered stars into the target element
      const starsHtml = renderStars(rating);
      const reviewCountHtml = `<span class="review-count">${result?.stats?.count} Reviews</span>`;

      // Insert the generated HTML into the target element
      target.innerHTML = starsHtml + reviewCountHtml;
    }
  };

  getStatus() {
    return this.status;
  }
  init() {
    try {
      this.main = document.querySelector('#bundle-cart-main');
      if (!this.main) {
        this.status = false;
        return;
      }

      this.variants = this.querySelectorAll('.product-variant-inner');
      this.imageSrc = this.getAttribute('data-image-src') || '';

      this.title = this.getAttribute('data-title') || '';

      this.subtitle = this.getAttribute('data-subtitle') || '';

      this.priceContainer =
        this.querySelector('.bundle-product-price') || this.querySelector('.snippet-data-prices .current');
      this.quantityWrapper = this.querySelector('.bundle-item-controls-wrap');
      this.quantitySelector = this.querySelector('.bundle-item-controls-wrap');
      this.quantityInput = this.querySelector('.bundle-item-controls-input');
      this.quantityMinus = this.querySelector('.bundle-item-controls-minus');
      this.quantityPlus = this.querySelector('.bundle-item-controls-plus');

      this.addToBundleBtn = this.querySelector('.bundle-item-add-to-bundle');
      // this.image = this.querySelector('.bundle-primary-image');
      // this.secondaryImage = this.querySelector('.bundle-secondary-image');
      this.state = [];
      // this.image.addEventListener('mouseenter', () => {
      //   const wrapperPosition = this.querySelector('.bundle-item-image-wrap').getAttribute('data-position');

      //   if (wrapperPosition !== 'main') {
      //     return;
      //   }
      //   if (this.secondaryImage) {
      //     const secondaryImageUrl = this.secondaryImage.getAttribute('src');
      //     if (secondaryImageUrl) {
      //       this.image.setAttribute('src', secondaryImageUrl);
      //     }
      //   }
      // });
      // this.image.addEventListener('mouseleave', () => {
      //   const originalImageUrl = this.image.getAttribute('data-image-src');
      //   this.image.setAttribute('src', originalImageUrl);
      // });
      this.status = false;
      this.quantityInput.addEventListener('change', (e) => {
        try {
          const newValue = e.target.value;
          // Update both attribute and property
          this.quantityInput.setAttribute('value', newValue);
          this.quantityInput.value = newValue;

          // Use setTimeout to ensure DOM updates before triggering the bundle update
          setTimeout(() => {
            this.updateVariantInBundle();
          }, 10);
        } catch (error) {
          console.error('Error handling input change:', error);
        }
      });

      this.variants.forEach((variant) => {
        const variantId = variant.getAttribute('data-variant-id');
        const label = variant.getAttribute('data-variant-label');
        const priceFormatted = variant.getAttribute('data-variant-price-formatted');
        const priceNoZero = variant.getAttribute('data-variant-price-no-zeroes');
        const priceRaw = variant.getAttribute('data-variant-price-raw');
        const price = variant.getAttribute('data-variant-price');
        const avaliable = variant.getAttribute('data-variant-available');

        const variantEntity = {
          variantId,
          quantity: 0,
          image_url: this.imageSrc,
          title: this.title,
          subtitle: this.subtitle,
          priceRaw,
          price,
          priceFormatted,
          priceNoZero,
          priceAfter: price,
          priceBefore: price,
          label: label,
        };
        this.state.push(variantEntity);
        this.main.collectVariants(variantEntity);
      });
      this.status = true;
      this.variants.forEach((variant, index) =>
        variant.addEventListener('click', () => {
          this.currentSelectedIndex = index;
          this.changeVariantInPlace();
        }),
      );
      // this.currentSelectedIndex = 0;
      this.addToBundleBtn.addEventListener('click', () => {
        this.updateVariantInBundle();
      });

      // Add event listeners only if elements exist
      if (this.quantityPlus) {
        this.quantityPlus.addEventListener('click', () => {
          this.incrementQuantity();
        });
      }

      if (this.quantityMinus) {
        this.quantityMinus.addEventListener('click', () => {
          this.decrementQuantity();
        });
      }
      this.currentSelectedIndex = [...this.variants].findIndex((variant) => {
        const data = variant.getAttribute('data-variant-available');

        if (data === 'true') {
          return true;
        }
      });

      this.changeVariantInPlace();
    } catch (e) {
      console.log('Error', e);
    }
  }
  getState() {
    return this.state;
  }
  updateVariantInBundle() {
    try {
      const amount = Number(this.quantityInput.getAttribute('value'));

      const response = this.main.requestVariantUpdate(this.state[this.currentSelectedIndex].variantId, amount);
      const itemInTheBundle = this.main.getItemInTheBundle(this.state[this.currentSelectedIndex].variantId);

      if (itemInTheBundle) {
        if (itemInTheBundle.quantity > 0) {
          // Item is in the bundle with quantity > 0
          this.classList.add('in-the-bundle');
          this.quantityWrapper.hidden = false;
          // Ensure the input value is correctly set (both attribute and property)
          const qty = itemInTheBundle.quantity;
          this.quantityInput.setAttribute('value', qty);
          this.quantityInput.value = qty;
        } else {
          // Item is not in the bundle (quantity = 0)
          this.classList.remove('in-the-bundle');
          this.quantityWrapper.hidden = true;

          // Reset quantity input to 1
          this.quantityInput.setAttribute('value', 1);
          this.quantityInput.value = 1;
        }
      }
    } catch (error) {
      console.error('Error updating variant in bundle:', error);
    }
  }
  incrementQuantity() {
    try {
      const currentValue = Number(this.quantityInput.getAttribute('value'));
      const newValue = currentValue + 1;

      // Update both attribute and value property
      this.quantityInput.setAttribute('value', newValue);
      this.quantityInput.value = newValue;

      // Force DOM update with a brief delay before triggering the bundle update
      setTimeout(() => {
        this.updateVariantInBundle();
      }, 10);
    } catch (error) {
      console.error('Error incrementing quantity:', error);
    }
  }
  decrementQuantity() {
    try {
      console.log('bundle.js: decrementQuantity called');
      const currentValue = Number(this.quantityInput.getAttribute('value'));
      let newValue = currentValue - 1;
      if (newValue < 0) {
        newValue = 0;
      }
      console.log('bundle.js: decrementing from', currentValue, 'to', newValue);

      // Update both attribute and value property
      this.quantityInput.setAttribute('value', newValue);
      this.quantityInput.value = newValue;

      // Force DOM update with a brief delay before triggering the bundle update
      setTimeout(() => {
        this.updateVariantInBundle();
      }, 10);
    } catch (error) {
      console.error('Error decrementing quantity:', error);
    }
  }
  changeVariantInPlace() {
    try {
      if (this.currentSelectedIndex === -1) {
        this.addToBundleBtn.classList.add('button-disabled');
        return;
      }

      const result = this.main.getItemInTheBundle(this.state[this.currentSelectedIndex].variantId);
      if (!result) {
        return;
      }

      this.addToBundleBtn.classList.remove('button-disabled');
      if (this.priceContainer) {
        this.priceContainer.innerText = this.state[this.currentSelectedIndex].priceNoZero;
      }

      this.variants.forEach((variant, index) => {
        if (index === this.currentSelectedIndex) {
          if (result.quantity > 0) {
            // Explicitly set both attribute and property value
            const qty = result.quantity;
            this.quantityInput.setAttribute('value', qty);
            this.quantityInput.value = qty;

            this.classList.add('in-the-bundle');
            this.quantityWrapper.hidden = false;
          } else {
            // Set quantity to 1 when item is not in bundle
            this.quantityInput.setAttribute('value', 1);
            this.quantityInput.value = 1;

            this.quantityWrapper.hidden = false;
            this.classList.remove('in-the-bundle');
          }
          variant.classList.add('selected');
        } else {
          variant.classList.remove('selected');
        }
      });
    } catch (e) {
      console.error('Error in changeVariantInPlace:', e);
    }
  }
}
customElements.define('bundle-item', BundleItem);

class BundleCartColDescriptions extends HTMLElement {
  constructor() {
    super();
    this.descriptions = this.querySelectorAll('.collection-description');
  }
  updateDescriptionVisibility(collectionId) {
    this.descriptions.forEach((descr) => {
      const id = descr.getAttribute('data-collection-id');
      if (id === collectionId) {
        descr.classList.remove('b-e-hide');
      } else {
        descr.classList.add('b-e-hide');
      }
    });
  }
}
customElements.define('bundle-cart-col-descriptions', BundleCartColDescriptions);

class BundleUpsells extends HTMLElement {
  constructor() {
    super();
    this.collectionFilterId = this.getAttribute('data-upsells-collection');
    this.allItemsReference = document.querySelectorAll('bundle-item');
    // Array to store each node's original parent and index.
    this.affectedNodes = [];

    this.addEventListener('fireUpsell', () => {
      // Refresh the bundle items and process upsell nodes.
      this.allItemsReference = document.querySelectorAll('bundle-item');
      this.getItemsFromUpsellCollection();
    });

    this.upsellNode = this.querySelector('.upsell_items');
  }

  getItemsFromUpsellCollection() {
    this.affectedNodes = [];
    // Filter eligible upsell items.
    const upsellItems = [...this.allItemsReference].reduce((acc, item) => {
      const collections = item.querySelector('.variant-collection-ids').innerText.trim().slice(1, -1).split(',');
      const variantIsInTheCollection = collections.includes(this.collectionFilterId);

      if (variantIsInTheCollection) {
        const state = item.getState();
        const isUpsellInTheBundle = state.every((variant) => variant.quantity === 0);
        if (isUpsellInTheBundle) {
          acc.push(item);
        }
      }
      return acc;
    }, []);

    // Pick random indices from the eligible upsell items.
    const indices = this.getRandomIndices(upsellItems);
    indices.forEach((idx) => {
      const node = upsellItems[idx];

      // Store the node's original parent and index.
      const originalParent = node.parentElement;
      const originalIndex = Array.from(originalParent.children).indexOf(node);
      this.affectedNodes.push({ node, originalParent, originalIndex });

      // Modify the node for upsell display and move it to the upsell container.
      const updatedNode = this.changeDesign(node);
      this.upsellNode.appendChild(updatedNode);
    });
  }

  getRandomIndices(arr) {
    if (arr.length === 0) return [];
    if (arr.length <= 2) return Array.from({ length: arr.length }, (_, i) => i);

    const firstIndex = Math.floor(Math.random() * arr.length);
    let secondIndex;
    do {
      secondIndex = Math.floor(Math.random() * arr.length);
    } while (secondIndex === firstIndex);

    return [firstIndex, secondIndex];
  }

  changeDesign(node) {
    node.classList.add('ac-upsell-item');
    const imageWrapper = node.querySelector('.bundle-item-image-wrap');
    if (imageWrapper) {
      imageWrapper.setAttribute('data-position', 'upsells');
    }
    const inner = node.querySelector('.actions');
    const controls = node.querySelector('.actions');
    if (inner) inner.classList.add('ac-inner');
    if (controls) controls.classList.add('ac-controls');

    // Move the controls to the end of the node.
    if (controls) {
      node.appendChild(controls);
    }
    return node;
  }

  // External function to revert upsell modifications.
  revertUpsells() {
    this.affectedNodes.forEach(({ node, originalParent, originalIndex }) => {
      // Remove added styling classes.
      node.classList.remove('ac-upsell-item');
      const inner = node.querySelector('.bundle-item-inner');
      const imageWrapper = node.querySelector('.bundle-item-image-wrap');
      if (imageWrapper) {
        imageWrapper.setAttribute('data-position', 'main');
      }
      if (inner) inner.classList.remove('ac-inner');
      const controls = node.querySelector('.bundle-item-add-to-bundle');
      if (controls) controls.classList.remove('ac-controls');

      // Revert the controls element: append it to the .bundle-item-controls container as its last child.
      if (controls) {
        const controlsContainer = node.querySelector('.bundle-item-controls');
        if (controlsContainer) {
          // Remove the controls from its current position.
          controls.parentElement.removeChild(controls);
          // Append it as the last child to the container.
          controlsContainer.appendChild(controls);
        }
      }

      // Remove the node from its current parent (if it's still attached).
      if (node.parentElement) {
        node.parentElement.removeChild(node);
      }

      // Reinsert the node back into its original parent at the recorded index.
      if (originalParent) {
        if (originalIndex < originalParent.children.length) {
          originalParent.insertBefore(node, originalParent.children[originalIndex]);
        } else {
          originalParent.appendChild(node);
        }
      }
    });
    // Clear stored references.
    this.affectedNodes = [];
  }
}

customElements.define('bundle-upsells', BundleUpsells);
